export function BulletinNotesTab({
  value,
  isEditing,
  onChange,
  onEdit,
  onStopEditing,
}: {
  value: string;
  isEditing: boolean;
  onChange: (value: string) => void;
  onEdit: () => void;
  onStopEditing: () => void;
}) {
  return (
    <div className="sticky-bulletin-notes-editor space-y-3 animate-in fade-in duration-150">
      <div className="flex items-center justify-between">
        <p className="text-[11px] text-[var(--fintheon-muted)]">
          Personal trading notes. Always saved.
        </p>
        {!isEditing && value ? (
          <button
            type="button"
            onClick={onEdit}
            className="text-[9px] text-[var(--fintheon-accent)] transition-opacity hover:opacity-75"
          >
            Edit
          </button>
        ) : null}
      </div>
      {isEditing || !value ? (
        <div className="space-y-2">
          <textarea
            value={value}
            onChange={(event) => onChange(event.target.value)}
            onFocus={onEdit}
            onBlur={() => window.setTimeout(onStopEditing, 300)}
            placeholder="Jot down observations, patterns, reminders..."
            rows={6}
            className="sticky-bulletin-notes-textarea w-full resize-none rounded-lg bg-transparent px-3 py-2 text-[12px] leading-relaxed text-[var(--fintheon-text)] outline-none ring-1 ring-[var(--fintheon-accent)]/15 transition-shadow placeholder:text-[var(--fintheon-muted)]/45 focus:ring-[var(--fintheon-accent)]/30"
          />
          <p className="text-right text-[9px] italic text-[var(--fintheon-muted)]/60">
            Auto-saves
          </p>
        </div>
      ) : (
        <button
          type="button"
          onClick={onEdit}
          className="w-full rounded-lg px-3 py-2 text-left text-[12px] leading-relaxed text-[var(--fintheon-text)] transition-colors hover:bg-[var(--fintheon-text)]/[0.025]"
        >
          <span className="whitespace-pre-wrap">{value}</span>
        </button>
      )}
    </div>
  );
}
